<template>
	<div style="margin: auto; max-width: 900px">
		<div>
			<p id="title">Welcome! What would you like to do ?</p>
		</div>
		<v-row>
			<v-col class="d-flex justify-center align-center" cols="12" sm="4">
				<div class="d-flex flex-column" id="box">
					<span id="box-title">Learn how to set up your experience</span>
					<span id="box-content">A step-by-step guide</span>
					<span id="box-button" @click="goToGuide"
						>Go to guide
						<v-icon id="box-button-icon">mdi-play</v-icon>
					</span>
				</div>
			</v-col>
			<v-col class="d-flex justify-center align-center" cols="12" sm="4">
				<div class="d-flex flex-column" id="box">
					<span id="box-title">Start Now!</span>
					<span id="box-content">Watch our quick start guide</span>
					<span id="box-button" @click="watchVideo"
						>Watch tutorials
						<div id="box-button-img">
							<v-img
								max-height="18"
								max-width="18"
								:src="iconTutorial"
							></v-img>
						</div>
					</span>
				</div>
			</v-col>
			<v-col class="d-flex justify-center align-center" cols="12" sm="4">
				<div class="d-flex flex-column" id="box">
					<span id="box-title">View templates</span>
					<span id="box-content">Choose from our templated experiences</span>
					<span id="box-button" @click="showTemplates"
						>Select templates
						<div id="box-button-img">
							<v-img
								max-height="18"
								max-width="18"
								:src="iconSearch"
							></v-img>
						</div>
					</span>
				</div>
			</v-col>
		</v-row>
		<div
			class="d-flex flex-wrap justify-space-between mb-4"
			:style="{
				backgroundImage: 'url(' + background + ')',
				backgroundSize: 'contain !important',
				maxWidth: '765px',
				height: '430px',
				margin: 'auto',
				cursor: 'pointer'
			}"
			@click="letsGetStarted"
		></div>

		<v-dialog
			v-model="dialogVideo"
			:retain-focus="false"
			persistent
			no-click-animation
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card style="overflow-x: auto">
				<v-card-title class="headline">
					Watch Tutorials
					<v-spacer></v-spacer>
					<v-btn icon @click="closeDialogVideo">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4 mb-4"></v-divider>

				<div class="d-flex justify-center align-center">
					<iframe
						id="videoTutorial"
						class="d-flex justify-center align-center"
						:src="video"
						frameborder="0"
						allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay 'none'"
						scrolling="0"
						style="height: 87vh; width: 78%"
					>
					</iframe>
				</div>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="dialogAddByTemplate.show"
			:retain-focus="false"
			persistent
			no-click-animation
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card style="overflow-x: auto">
				<v-card-title class="headline">
					Experience Templates
					<v-spacer></v-spacer>
					<v-btn icon @click="dialogAddByTemplate.show = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4 mb-4"></v-divider>

				<v-col icon cols="4">
					<v-text-field label="Quick Search" v-model="dialogAddByTemplate.search" append-icon="mdi-magnify"></v-text-field>
				</v-col>

				<div class="d-flex flex-wrap justify-space-around align-stretch">
					<v-hover v-for="(template, index) in filterExperienceTemplateByName" :key="index" v-slot:default="{ hover }">
						<v-card :elevation="hover ? 4 : 2" width="340" class="mb-5">
							<div id="structure-view" style="display: block">
								<div class="entry-view">
									<v-img
										style="background-color: rgba(0, 0, 0, 0.05)"
										contain
										:src="$root.asset(template.imageTemplate)"
										max-height="200"
										min-height="200"
									></v-img>
									<v-card-title class="justify-center">{{ template.name }}</v-card-title>
									<v-card-text v-html="parseHtml(template.description)"></v-card-text>
									<v-btn icon style="position: absolute; right: 0; bottom: 0" @click="showRooms(template.id)">
										<v-icon>mdi-file-find</v-icon>
									</v-btn>
								</div>
							</div>
						</v-card>
					</v-hover>
				</div>
			</v-card>
		</v-dialog>
		
		<v-dialog
			v-model="dialogRooms"
			:retain-focus="false"
			persistent
			no-click-animation
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card style="overflow-x: auto">
				<v-card-title class="headline">
					Rooms
					<v-spacer></v-spacer>
					<v-btn icon @click="dialogRooms = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4 mb-4"></v-divider>

				<div class="d-flex flex-wrap justify-space-around align-stretch">
					<div v-for="(entity, index) in roomList" :key="index">
						<v-card :elevation="2" width="340" class="mb-5">
							<v-card-title>
								<span>{{ entity.name }}</span>
								<v-spacer></v-spacer>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-icon v-if="entity.mainStructure" v-bind="attrs" v-on="on" color="success"> mdi-home </v-icon>
									</template>
									<span>Entry Point</span>
								</v-tooltip>
							</v-card-title>
							<div class="v-card__text pa-0" style="position: relative; height: 200px; max-height: 200px; overflow: auto">
								<div style="position: absolute; transform-origin: top left; transform: scale(calc(340 / (1920 * 0.5)))">
									<img v-if="entity.backgroundDisplay" width="960px" :src="$root.asset(entity.backgroundDisplay)" />
									<img v-else-if="$root.isImage(entity.background)" width="960px" :src="$root.asset(entity.background)" />
									<video
										v-else-if="$root.isVideo(entity.background)"
										width="960px"
										preload="auto"
										autoplay="autoplay"
										muted
										playsinline
										disablepictureinpicture
										loop="loop"
									>
										<source :src="$root.asset(entity.background)" type="video/mp4" />
									</video>
									<template v-else-if="$root.isYoutubeUrl(entity.background)">
										<youtube
											:videoId="$root.getYoutubeId(entity.background, backgroundYoutubeParams)"
											:player-vars="$root.getYoutubeParams(entity.background)"
											style="pointer-events: none"
											width="960"
											height="530"
											ref="backgroundIndexYoutube"
										></youtube>
									</template>
									<vimeo-player 
										v-else-if="$root.isVimeoUrl(entity.background)"
										:video-url="entity.background"
										:options="backgroundVimeoParams"
										style="pointer-events: none"
										player-width="960"
										player-height="auto"
										ref="background"
									></vimeo-player>
									<div v-for="(item, index) in entity.linkToDataList" :key="index">
										<img
											v-if="item.type === 'Image'"
											:src="$root.asset(item.value)"
											:style="{
												zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
												width: item.width + 'px',
												height: item.height + 'px',
												objectFit: $root.setBackgroundSize(item.subType),
												objectPosition: $root.setBackgroundPosition(item),
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												position: 'absolute'
											}"
										/>
										<iframe
											v-else-if="item.type === 'Video' && $root.isEmbedVideo(item.value)"
											:style="{
												zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												position: 'absolute'
											}"
											frameborder="0"
											allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture;"
											scrolling="0"
											:src="$root.asset($root.appendMuteVideo(item.value))"
										>
										</iframe>
										<video
											v-else-if="item.type === 'Video'"
											:style="{
												backgroundColor: '#000000',
												zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												position: 'absolute'
											}"
											frameborder="0"
											autoplay
											muted
											playsinline
											scrolling="0"
											:src="$root.asset(item.value)"
										></video>
										<div
											v-else-if="item.type === 'Text'"
											class="hotspot_text"
											v-html="item.value"
											:style="{
												zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform:
													'skew(' + (item.skewX ? item.skewX : '0') + 'deg,' + (item.skewY ? item.skewY : '0') + 'deg)',
												position: 'absolute',
												backgroundColor: item.backgroundColor,
												borderStyle: item.borderWidth === 'none' ? item.borderWidth : 'solid',
												borderWidth: item.borderWidth,
												borderColor: item.borderColor,
												padding: (item.padding ? item.padding / 4 : '0') + 'px'
											}"
										></div>
										<div
											v-else-if="item.type === 'Embed_HTML' && item.target === 'Embed'"
											:style="{
												zIndex: layerMode == true ? entity.linkToDataList.length - index : 1,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												position: 'absolute',
												overflow: 'hidden'
											}"
											v-append="item.valueRender ? item.valueRender : item.value"
										></div>
										<v-btn
											v-else-if="item.type === 'Button' && !item.backgroundImage"
											:class="'hotspot_btn hotspot_btn_custom_' + item.id"
											absolute
											:color="item.backgroundColor"
											:style="{
												zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												textTransform: 'none',
												borderStyle: item.borderWidth === 'none' ? item.borderWidth : 'solid',
												borderRadius: item.borderRadius + 'px',
												borderWidth: item.borderWidth + 'px',
												borderColor: item.borderColor
											}"
										>
											<div v-html="item.css ? item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>' : item.value"></div>
										</v-btn>
										<v-btn
											v-else-if="item.type === 'Button' && item.backgroundImage"
											:class="'hotspot_btn hotspot_btn_custom_' + item.id"
											absolute
											:style="{
												backgroundImage: 'url(' + item.backgroundImage + ')',
												zIndex: layerMode == true ? entity.linkToDataList.length - index : 2,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
												textTransform: 'none',
												borderStyle: item.borderWidth === 'none' ? item.borderWidth : 'solid',
												borderRadius: item.borderRadius + 'px',
												borderWidth: item.borderWidth + 'px',
												borderColor: item.borderColor
											}"
										>
											<div v-html=" item.css ? item.value + '<style scoped>' + item.css.replace(/hotspot_btn_custom/g, 'hotspot_btn_custom_' + item.id) + '</style>' : item.value"></div>
										</v-btn>
										<router-link
											v-else
											class="room-link"
											to="#"
											:style="{
												zIndex: layerMode == true ? entity.linkToDataList.length - index : 3,
												width: item.width + 'px',
												height: item.height + 'px',
												top: item.posY + 'px',
												left: item.posX + 'px',
												transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)'
											}"
										></router-link>
									</div>
									<div
										v-if="
											entity.dataMap.isExhibitionHall &&
											entity.dataMap.boothSelected != null &&
											entity.dataMap.boothSelected.length > 0
										"
										class="d-flex justify-center"
										style="position: absolute; z-index:1; top: 0; right: 0, bottom:0; width: auto; min-width:100%; max-height:100%;"
									>
										<v-row class="d-flex justify-center mx-0">
											<v-col
												cols="8"
												class="my-4"
												style="background-color: rgba(0, 0, 0, 0.5); overflow-y: auto; max-height: 90%"
											>
												<v-list style="background-color: rgba(0, 0, 0, 0)" dark dense>
													<div v-for="(item, index) in getBoothSelectedList(entity.dataMap.boothSelected)" :key="index">
														<v-list-item
															v-if="item != null && item.boothBackground.type == 'Color'"
															link
															v-bind:style="{ backgroundColor: item.boothBackground.color }"
														>
															<v-list-item-avatar size="30" color="grey lighten-2">
																<v-img :src="$root.asset(item.logo)"></v-img>
															</v-list-item-avatar>
															<v-list-item-content>{{ item.name }}</v-list-item-content>
														</v-list-item>
														<v-list-item
															v-else-if="item != null && item.boothBackground.type == 'Upload'"
															link
															v-bind:style="{ backgroundImage: 'url(' + item.boothBackground.image + ')' }"
														>
															<v-list-item-avatar size="30" color="grey lighten-2">
																<v-img :src="$root.asset(item.logo)"></v-img>
															</v-list-item-avatar>
															<v-list-item-content>{{ item.name }}</v-list-item-content>
														</v-list-item>
														<v-divider></v-divider>
													</div>
												</v-list>
											</v-col>
										</v-row>
									</div>

									<div
										v-if="
											entity.dataMap.isPosterRoom &&
											entity.dataMap.posterSelected != null &&
											entity.dataMap.posterSelected.length > 0 &&
											posterList.length > 0
										"
										class="d-flex justify-center"
										style="position: absolute; z-index:1; top: -40px; right: 0, bottom:0; width: auto; min-width:260%; max-height:100%;transform: scale(0.38); margin-left: -768px"
									>
										<v-row style="height: 570px">
											<v-col cols="12" style="padding: 0px 40px">
												<div style="overflow: auto; max-height: 880px; background-color: #00000070">
													<v-carousel
														v-model="posterPage[index]"
														height="100%"
														hide-delimiters
														next-icon="mdi-arrow-right-circle"
														prev-icon="mdi-arrow-left-circle"
													>
														<v-carousel-item
															v-for="page in Math.ceil(entity.dataMap.posterSelected.length / 4)"
															:key="page"
														>
															<v-row class="d-flex justify-center mx-0;" style="postion: absolute">
																<v-col
																	cols="3"
																	class="my-4"
																	v-for="(poster, idxPoster) in getPosterSelectedList(
																		entity.dataMap.posterSelected,
																		page
																	)"
																	:key="idxPoster"
																>
																	<v-card style="background-color: #00000000">
																		<v-card-title class="justify-center">
																			<span class="headline" style="color: white">{{ poster.name }}</span>
																		</v-card-title>
																		<v-card-text>
																			<div
																				style="
																					margin: 10px;
																					width: 555px;
																					margin: auto;
																					border-top-left-radius: 12px;
																					border-top-right-radius: 12px;
																					padding: 5px;
																				"
																				:style="{ backgroundColor: poster.backgroundColor }"
																			>
																				<v-row
																					v-for="(item, index) in poster.posterDataList"
																					:key="index"
																					style="margin: 5px; padding: 0px"
																				>
																					<v-col
																						v-for="(item1, index1) in item"
																						:key="index1"
																						:cols="12 / item.length"
																						style="padding: 1px"
																					>
																						<v-btn
																							v-if="item1.type == 'URL FIELD'"
																							width="100%"
																							:color="item1.backgroundColor"
																							:style="{ color: item1.fontColor }"
																						>
																							{{ item1.label }}
																						</v-btn>
																						<v-btn
																							v-else-if="item1.type == 'FILE DOWNLOAD'"
																							width="100%"
																							:color="item1.backgroundColor"
																							:style="{ color: item1.fontColor }"
																						>
																							{{ item1.label }}
																							<v-icon :color="item1.iconColor" medium
																								>mdi-download</v-icon
																							>
																						</v-btn>
																						<div
																							v-else-if="item1.type == 'TEXT'"
																							v-html="item1.value"
																							:style="{
																								backgroundColor: item1.backgroundColor,
																								border: '1px solid ' + item1.backgroundColor
																							}"
																							style="
																								border: 1px solid black;
																								padding: 10px 10px 0px 10px;
																							"
																						></div>
																						<v-carousel
																							v-else-if="item1.type == 'GALLERY'"
																							hide-delimiters
																							height="368"
																						>
																							<v-carousel-item
																								v-for="(image, idxImage) in item1.images"
																								class="galley_poster"
																								:key="idxImage"
																								:src="$root.asset(image)"
																								reverse-transition="fade"
																								transition="fade"
																							>
																							</v-carousel-item>
																						</v-carousel>
																						<iframe
																							v-else-if="item1.type == 'VIDEO'"
																							id="video_poster"
																							:src="$root.asset(item1.value)"
																							frameborder="0"
																							allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay 'none'"
																							scrolling="0"
																							width="100%"
																							height="300px"
																						>
																						</iframe>
																					</v-col>
																				</v-row>
																			</div>
																		</v-card-text>
																	</v-card>
																</v-col>
															</v-row>
														</v-carousel-item>
													</v-carousel>
												</div>
											</v-col>
										</v-row>
									</div>
								</div>
							</div>
						</v-card>
					</div>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>
<style scoped>
#title {
	font-size: 40px;
	font-family: "Helvetica", Fantasy;
	font-weight: bold;
	text-align: center;
	color: #003366;
	margin: 10px 0px 0px 0px;
	max-width: 900px;
}
#box {
	background-color: #039be5;
	margin-left: 15px;
	width: 240px;
	height: 205px;
	position: relative;
}
#box-title {
	margin: 5px 15px 10px 15px;
	font-size: 32px;
	font-family: "Helvetica", Fantasy;
	font-weight: bold;
	line-height: normal;
	color: white;
}
#box-content {
	margin-left: 15px;
	font-size: 18px;
	font-family: "Helvetica", Fantasy;
	font-weight: bold;
	color: #003366;
}
#box-button {
	margin: 5px 15px 10px 15px;
	padding: 3px 0px 3px 20px;
	border-radius: 20px;
	font-size: 18px;
	font-family: "Helvetica", Fantasy;
	font-weight: bold;
	background-color: #003366;
	color: white;
	position: absolute;
	bottom: 0px;
	width: 200px;
	cursor: pointer;
}
#box-button-icon {
	margin-right: 5px;
	margin-top: 1px;
	border-radius: 20px;
	background-color: #039be5;
	float: right;
	color: #003366;
}
#box-button-img {
	margin-right: 5px;
	margin-top: 1px;
	padding: 3px;
	border-radius: 20px;
	background-color: #039be5;
	float: right;
	color: #003366;
}
#box-button-img2 {
	margin-right: 5px;
	margin-top: 1px;
	padding: 5px;
	border-radius: 20px;
	background-color: #039be5;
	float: right;
	color: #003366;
}
</style>
<script>
import axios from "axios";

export default {
	data() {
		return {
			background: axios.defaults.baseURL + "/resource/image/empty-state/lets-get-started.png",
			iconTutorial: axios.defaults.baseURL + "/resource/image/empty-state/tutorials.png",
			iconSearch: axios.defaults.baseURL + "/resource/image/empty-state/search.png",
			video: "https://vimeo.com/showcase/9389602",
			dialogVideo: false,
			dialogRooms: false,
			dialogAddByTemplate: {
				show: false,
				selected: null,
				search: ""
			},
			experienceTemplateList: [],
			roomList: [],
			booths: [],
			posterList: [],
			posterPage: [],
			layerMode: false,
			backgroundYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1, loop: 1, playlist: ''},
			backgroundVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false, loop: true},
		};
	},
	mounted() {
	},
	computed: {
		filterExperienceTemplateByName() {
			return this.experienceTemplateList.filter((experience) => {
				return experience.name.toLowerCase().includes(this.dialogAddByTemplate.search);
			});
		}
	},
	methods: {
		goToGuide() {
			window.location.href = "/#/tenant/trainingAndTutorial";
		},
		watchVideo() {
			window.open(this.video, "_blank");
		},
		showTemplates() {
			this.listExperienceTemplate();
			this.dialogAddByTemplate.show = true;
		},
		listExperienceTemplate() {
			axios
				.get("/system/experience/template/list")
				.then((response) => {
					this.experienceTemplateList = response.data;
				})
				.catch(() => {});
		},
		async showRooms(id) {
			await axios
				.post("/system/experience", {
					id: id
				})
				.then((response) => {
					this.layerMode = response.data.layerMode;
				})
				.catch(() => {});

			axios.get("/system/structure/list?experienceId=" + id).then((response) => {
				this.roomList = response.data;
				// Check if small asset is exist and use it
				let vm = this;
				this.roomList.map(obj => {
					vm.$root.isImageExist(vm.$root.smallAsset(obj.background), function(status) {
						if (status) {
							obj.background = vm.$root.smallAsset(obj.background)
						}
					});
					return obj;
				});
				this.listBooth(id);
				this.listPoster(id);
				this.dialogRooms = true;

				this.$nextTick(() => {
					if (this.$vuetify.breakpoint.mobile){
						this.$root.playYoutube(this.$refs.backgroundIndexYoutube);
					}
				});
			});
		},
		letsGetStarted() {
			window.location.href = "/#/tenant/experience/add/template";
		},
		closeDialogVideo() {
			var videos = document.querySelectorAll('iframe, video');
			Array.prototype.forEach.call(videos, function (video) {
				if (video.tagName.toLowerCase() === 'video') {
					video.pause();
				} else {
					var src = video.src;
					video.src = src;
				}
			});
			this.dialogVideo = false;
		},
		parseHtml(desc) {
			if (desc) {
				desc = desc.replace(/\n/g, '</p><p style="text-align: center">');
				return '<p style="text-align: center">' + desc + "</p>";
			}
			return desc;
		},
		getBoothSelectedList(boothList) {
			let result = [];
			let listBooth = Object.assign([], boothList);
			for (let i = 0; i < listBooth.length; i++) {
				let list = this.$root.clone(this.booths);
				result.push(list.filter((item) => listBooth[i] == item.id)[0]);
			}
			return result;
		},
		listBooth(id) {
			axios.get("/system/booth/list?experienceId=" + id).then((response) => {
				this.booths = response.data;
			});
		},
		listPoster(id) {
			axios.get("/system/poster/find?&experienceId=" + id).then((response) => {
				this.posterList = response.data;
			});
		},
		getPosterSelectedList(posterList, page) {
			let result = [];
			let start = (page-1) * 4;
			let end = page * 4;
			if (posterList.length < end) {
				end = posterList.length;
			}
			
			let listPoster = Object.assign([], posterList);
			for (let i = start; i < end; i++) {
				let list = this.$root.clone(this.posterList);
				let poster = list.filter((item) => listPoster[i] == item.id)[0];
				if(poster){
					for (let item of poster.posterDataList) {
						for (let item1 of item) {
							if (item1.type === "GALLERY") {
								let length = item1.images.length;
								// for hide default image
								item1.images.splice(length - 1, 1);
							}
						}
					}
					result.push(poster);
				}
			}
			return result;
		},
	}
};
</script>
